import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/react-table';

interface Props {
  pagination: PaginationState;
  sorting: SortingState;
  columnFilters: ColumnFiltersState;
}

export const buildPageSortFilterParams = ({ pagination, sorting, columnFilters }: Props) => {
  const params = new URLSearchParams();

  if (pagination) {
    params.append('page_size', pagination.pageSize.toString());
    params.append('page', (pagination.pageIndex + 1).toString());
  }

  if (sorting.length) {
    params.append('ordering', sorting.map(({ id, desc }) => (desc ? `-${id}` : id)).join(','));
  }

  if (columnFilters.length) {
    columnFilters.forEach((filter) => {
      params.append(filter.id, filter.value as string);
    });
  }

  return params;
};
